// import components
import { GridColDef } from '@mui/x-data-grid-pro';

// import external libraries
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// import types
import { DutyLineGridRow } from '../HoursTable.types';
import { dateAndTimeFormatter, nestedFieldValueGetter } from 'utils/grid';

export const useGetDutyHistoryColumns = () => {
  const { t: tRoot } = useTranslation('common');
  const { t } = useTranslation('common', {
    keyPrefix: 'hoursTable.dutyInformation'
  });

  return useMemo<GridColDef[]>(
    () => [
      {
        headerName: t('updatedDate'),
        field: 'audit.operationTimestamp',
        type: 'string',
        editable: false,
        valueGetter: (_, row: DutyLineGridRow) =>
          nestedFieldValueGetter('audit.operationTimestamp', row),
        valueFormatter: dateAndTimeFormatter
      },
      {
        headerName: t('updatedBy'),
        field: 'audit.operationUserName',
        type: 'string',
        editable: false,
        valueGetter: (_, row: DutyLineGridRow) =>
          nestedFieldValueGetter('audit.operationUserName', row)
      },
      {
        headerName: tRoot('employee'),
        field: 'employeeName',
        type: 'string',
        editable: false
      },
      {
        headerName: t('operation'),
        field: 'audit.operation',
        type: 'string',
        width: 60,
        headerAlign: 'center',
        align: 'center',
        editable: false,
        valueGetter: (_, row: DutyLineGridRow) =>
          nestedFieldValueGetter('audit.operation', row)
      },
      {
        headerName: tRoot('wa'),
        field: 'waNr',
        type: 'string',
        width: 50,
        headerAlign: 'center',
        align: 'center',
        editable: false
      },
      {
        headerName: tRoot('costCenter'),
        field: 'customerBrName',
        type: 'string',
        editable: false,
        flex: 1
      },
      {
        headerName: tRoot('dutyCode'),
        field: 'dutyCode',
        type: 'string',
        width: 80,
        headerAlign: 'center',
        align: 'center',
        editable: false
      },
      {
        headerName: t('hoursNominal'),
        field: 'hoursNominal',
        type: 'string',
        align: 'center',
        editable: false
      },
      {
        headerName: tRoot('approved'),
        field: 'flags.APPROVED',
        type: 'string',
        editable: false,
        valueGetter: (_, row: DutyLineGridRow) =>
          row?.flags?.includes('APPROVED')
            ? t('status.APPROVED')
            : t('status.WAITING_FOR_APPROVAL')
      },
      {
        headerName: t('calculationDate'),
        field: 'calculationDate',
        type: 'string',
        editable: false,
        valueFormatter: dateAndTimeFormatter
      },
      {
        headerName: t('statusCalculated.label'),
        field: 'flags.STATUS_CALCULATED',
        type: 'string',
        editable: false,
        valueGetter: (_, row: DutyLineGridRow) =>
          row?.flags?.includes('STATUS_CALCULATED')
            ? t('statusCalculated.yes')
            : t('statusCalculated.no')
      }
    ],
    [t]
  );
};
